import React from 'react';
export function FloatingBanner() {
  return <div className="fixed bottom-0 left-0 w-full z-50 animate-fade-in-up" data-id="element-18">
      <div className="bg-gradient-to-r from-[#B8941F] via-[#E5C158] to-[#B8941F] py-3 px-4 shadow-[0_-10px_30px_rgba(212,175,55,0.2)]" data-id="element-19">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6" data-id="element-20">
          <div className="flex items-center gap-2" data-id="element-21">
            <span className="w-2.5 h-2.5 rounded-full bg-red-600 animate-pulse shadow-[0_0_8px_rgba(220,38,38,0.8)]" data-id="element-22" />
            <p className="text-black font-bold text-sm sm:text-base text-center tracking-tight" data-id="element-23">
              ¡QUEDAN POCOS CUPOS PARA ACCEDER AL ACELERADOR X10!
            </p>
          </div>
          <a href="#pricing" className="bg-black text-[#D4AF37] hover:bg-neutral-900 px-5 py-1.5 rounded-full text-xs sm:text-sm font-bold transition-colors whitespace-nowrap border border-black/20" data-id="element-24">
            VER OFERTA →
          </a>
        </div>
      </div>
    </div>;
}